import moment from 'moment';
import React from 'react';
import { Row, Col, Alert } from 'reactstrap';

export default class ErrorMessages extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const errors = this.props.validation;
    const hasErrors = Object.values(errors).includes(false);
    if (hasErrors) {
      return (
        <Row>
          <Col className="form-col">
            <Alert color="danger">
              Die von Ihnen angegebenen Informationen sind nicht vollständig. Bitte überprüfen Sie Ihre Angaben.
            </Alert>
          </Col>
        </Row>
      )
    } else {
      return (null)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/ErrorMessages.js